<template>
  <div class="services-page">
    <Header />
    
    <div class="services-container">
      <!-- 页面标题 -->
      <div class="page-header">
        <h1 class="main-title">解决方案与产品</h1>
        <p class="subtitle">chmura云通讯为您提供全方位的通信技术解决方案</p>
      </div>

      <!-- 解决方案与产品案例展示 -->
      <div class="services-grid">
        <!-- 运营商网络 -->
        <div class="service-card">
          <div class="card-image">
            <img src="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="运营商网络">
          </div>
          <div class="card-content">
            <h3 class="card-title">运营商网络</h3>
            <p class="card-description">
              构建下一代智能通信基础设施，引领5G时代的通信网络架构。我们的网络架构融合了云计算、大数据、AI等前沿技术，为全球运营商提供端到端的5G网络部署和优化服务。截至2025年，chmura云通讯已在全球20多个国家和地区部署了5G网络，覆盖超过150个城市，服务用户突破3亿。
            </p>
            <div class="card-footer">
              <el-button type="primary" size="small" @click="$router.push('/carrier-network')" class="bg-blue-600 hover:bg-blue-700">
                了解更多 →
              </el-button>
            </div>
          </div>
        </div>

        <!-- 政企解决方案 -->
        <div class="service-card">
          <div class="card-image">
            <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="政企解决方案">
          </div>
          <div class="card-content">
            <h3 class="card-title">政企解决方案</h3>
            <p class="card-description">
              为政府和企业提供定制化的通信解决方案，助力数字化转型。我们的政企解决方案涵盖了智能办公、视频会议、应急通信、物联网应用等多个领域。通过与政府部门和大型企业的深入合作，我们打造了一系列具有行业特色的创新解决方案。
            </p>
            <div class="card-footer">
              <el-button type="primary" size="small" @click="$router.push('/government-enterprise')" class="bg-blue-600 hover:bg-blue-700">
                了解更多 →
              </el-button>
            </div>
          </div>
        </div>

        <!-- 消费者终端 -->
        <div class="service-card">
          <div class="card-image">
            <img src="https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="消费者终端">
          </div>
          <div class="card-content">
            <h3 class="card-title">消费者终端</h3>
            <p class="card-description">
              提供多样化的智能终端产品，满足消费者的通信需求。我们的消费者终端产品包括智能手机、平板电脑、智能手表、智能音箱等多种设备。通过持续的技术创新和用户体验优化，我们的产品在市场上获得了良好的口碑。
            </p>
            <div class="card-footer">
              <el-button type="primary" size="small" @click="$router.push('/consumer-terminal')" class="bg-blue-600 hover:bg-blue-700">
                了解更多 →
              </el-button>
            </div>
          </div>
        </div>

        <!-- 5G技术 -->
        <div class="service-card">
          <div class="card-image">
            <img src="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="5G技术">
          </div>
          <div class="card-content">
            <h3 class="card-title">5G技术</h3>
            <p class="card-description">
              深耕5G技术研发，推动通信技术的创新与发展。我们在5G核心技术领域拥有深厚的积累，包括Massive MIMO、波束赋形、网络切片、边缘计算等。通过与产业链合作伙伴的紧密协作，我们积极推动5G技术的应用和普及。
            </p>
            <div class="card-footer">
              <el-button type="primary" size="small" @click="$router.push('/5g-technology')" class="bg-blue-600 hover:bg-blue-700">
                了解更多 →
              </el-button>
            </div>
          </div>
        </div>

        <!-- 云计算与大数据 -->
        <div class="service-card">
          <div class="card-image">
            <img src="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="云计算与大数据">
          </div>
          <div class="card-content">
            <h3 class="card-title">云计算与大数据</h3>
            <p class="card-description">
              提供强大的云计算和大数据服务，助力企业实现数字化转型。我们的云计算平台提供了弹性计算、存储、数据库、人工智能等多种服务。通过大数据分析技术，我们帮助企业挖掘数据价值，提升运营效率和决策能力。
            </p>
            <div class="card-footer">
              <el-button type="primary" size="small" @click="$router.push('/cloud-big-data')" class="bg-blue-600 hover:bg-blue-700">
                了解更多 →
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <Footer />
    <BackToTop />
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
import BackToTop from '../components/BackToTop.vue'

export default {
  name: 'Services',
  components: {
    Header,
    Footer,
    BackToTop
  }
}
</script>

<style scoped>
.services-page {
  padding-top: 80px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.services-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.page-header {
  text-align: center;
  margin-bottom: 60px;
}

.main-title {
  font-size: 3rem;
  font-weight: bold;
  color: #303133;
  margin-bottom: 16px;
  background: linear-gradient(135deg, #409EFF 0%, #67C23A 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.subtitle {
  font-size: 1.2rem;
  color: #606266;
  max-width: 800px;
  margin: 0 auto;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 30px;
  justify-items: center;
}

.service-card {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
  max-width: 400px;
  display: flex;
  flex-direction: column;
}

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(64, 158, 255, 0.3);
}

.card-image {
  height: 200px;
  overflow: hidden;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.service-card:hover .card-image img {
  transform: scale(1.1);
}

.card-content {
  padding: 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.card-title {
  font-size: 1.5rem;
  font-weight: bold;
  color: #303133;
  margin-bottom: 16px;
}

.card-description {
  font-size: 1rem;
  line-height: 1.6;
  color: #606266;
  margin-bottom: 20px;
  flex: 1;
}

.card-footer {
  margin-top: auto;
  text-align: right;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .main-title {
    font-size: 2.5rem;
  }
  
  .subtitle {
    font-size: 1.1rem;
  }
  
  .services-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .services-container {
    padding: 20px 10px;
  }
  
  .card-content {
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .main-title {
    font-size: 2rem;
  }
  
  .subtitle {
    font-size: 1rem;
  }
}
</style>